<template>
    <div id="radial-graph">
        <!-- Nuevo gauge -->
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
             viewBox="0 0 201.81 201.81">
            <defs>
                <linearGradient id="linear-gradient" x1="100.9" y1="201.81" x2="100.9"
                                gradientUnits="userSpaceOnUse">
                    <stop offset="0" stop-color="#494949"/>
                    <stop offset="0.51" stop-color="#7f7f7f"/>
                    <stop offset="1" stop-color="#494949"/>
                </linearGradient>
                <linearGradient id="linear-gradient-2" x1="31.07" y1="170.74" x2="170.74" y2="31.07"
                                gradientUnits="userSpaceOnUse">
                    <stop offset="0" stop-color="#828282"/>
                    <stop offset="0.51" stop-color="#cdcdcd"/>
                    <stop offset="0.7" stop-color="#b4b4b4"/>
                    <stop offset="1" stop-color="#828282"/>
                </linearGradient>
                <linearGradient id="linear-gradient-3" x1="100.9" y1="198.66" x2="100.9" y2="3.15"
                                gradientTransform="translate(184.55 -14.71) rotate(80.88)"
                                gradientUnits="userSpaceOnUse">
                    <stop offset="0" stop-color="#535353"/>
                    <stop offset="0.51" stop-color="#bababa"/>
                    <stop offset="0.65" stop-color="#a1a1a1"/>
                    <stop offset="0.94" stop-color="#606060"/>
                    <stop offset="1" stop-color="#535353"/>
                </linearGradient>
                <linearGradient id="linear-gradient-4" x1="100.9" y1="193.87" x2="100.9" y2="7.93"
                                gradientTransform="translate(184.54 -14.71) rotate(80.88)"
                                gradientUnits="userSpaceOnUse">
                    <stop offset="0" stop-color="#a2a2a1"/>
                    <stop offset="0.51" stop-color="#444"/>
                    <stop offset="1" stop-color="#a2a2a1"/>
                </linearGradient>
                <radialGradient id="radial-gradient" cx="100.9" cy="100.9" r="91.33"
                                gradientTransform="translate(100.9 -41.8) rotate(45)"
                                gradientUnits="userSpaceOnUse">
                    <stop offset="0.79" stop-color="#fff"/>
                    <stop offset="0.89" stop-color="#fdfdfd"/>
                    <stop offset="0.92" stop-color="#f6f6f6"/>
                    <stop offset="0.95" stop-color="#ebebeb"/>
                    <stop offset="0.97" stop-color="#dadada"/>
                    <stop offset="0.99" stop-color="#c4c4c4"/>
                    <stop offset="1" stop-color="#b0b0b0"/>
                </radialGradient>
            </defs>
            <g id="Capa_2" data-name="Capa 2">
                <g id="Capa_1-2" data-name="Capa 1">
                    <circle class="gauge_cls-1" cx="100.9" cy="100.9" r="100.9"/>
                    <circle class="gauge_cls-2" cx="100.9" cy="100.9" r="98.77"/>
                    <circle class="gauge_cls-3" cx="100.9" cy="100.9" r="97.75"
                            transform="translate(-14.71 184.55) rotate(-80.88)"/>
                    <circle class="gauge_cls-4" cx="100.9" cy="100.9" r="92.97"
                            transform="translate(-14.71 184.54) rotate(-80.88)"/>
                    <circle class="gauge_cls-5" cx="100.9" cy="100.9" r="91.33"
                            transform="translate(-41.8 100.9) rotate(-45)"/>
                    <path class="gauge_cls-6"
                          d="M101.78,61.75a40.14,40.14,0,0,1,5.06.44l2.82-16a55.22,55.22,0,0,0-7.88-.68Z"/>
                    <path class="gauge_cls-6" d="M95,62.19a40,40,0,0,1,5.06-.44V45.53a55.22,55.22,0,0,0-7.88.68Z"/>
                    <path class="gauge_cls-7"
                          d="M88.33,63.8a40.29,40.29,0,0,1,4.91-1.31l-2.82-16a54.23,54.23,0,0,0-7.63,2Z"/>
                    <path class="gauge_cls-8"
                          d="M115.12,64.41a37.72,37.72,0,0,1,4.6,2.14l8.11-14a54.91,54.91,0,0,0-7.16-3.34Z"/>
                    <path class="gauge_cls-7"
                          d="M108.57,62.49a40.13,40.13,0,0,1,4.9,1.31L119,48.56a54.23,54.23,0,0,0-7.63-2Z"/>
                    <path class="gauge_cls-8"
                          d="M82.09,66.55a37,37,0,0,1,4.6-2.14L81.14,49.16A55.66,55.66,0,0,0,74,52.5Z"/>
                    <path class="gauge_cls-9"
                          d="M67.43,80.57a38.83,38.83,0,0,1,2.92-4.16L57.92,66a56.06,56.06,0,0,0-4.54,6.47Z"/>
                    <path class="gauge_cls-10" d="M64.41,86.69a37,37,0,0,1,2.14-4.6L52.5,74a57,57,0,0,0-3.34,7.17Z"/>
                    <path class="gauge_cls-11"
                          d="M76.41,70.35a41.29,41.29,0,0,1,4.15-2.92L72.45,53.38A56.06,56.06,0,0,0,66,57.92Z"/>
                    <path class="gauge_cls-10"
                          d="M135.25,82.09a38.59,38.59,0,0,1,2.15,4.6l15.25-5.55A55.72,55.72,0,0,0,149.3,74Z"/>
                    <path class="gauge_cls-12"
                          d="M139.62,95a38.22,38.22,0,0,1,.43,5.06h16.22a55.22,55.22,0,0,0-.68-7.88Z"/>
                    <path class="gauge_cls-13"
                          d="M71.48,75.07a38,38,0,0,1,3.59-3.59L64.64,59.05a54.63,54.63,0,0,0-5.59,5.59Z"/>
                    <path class="gauge_cls-14"
                          d="M130.33,126.74a40.54,40.54,0,0,1-3.59,3.59l10.43,12.43a56.72,56.72,0,0,0,5.59-5.59Z"/>
                    <path class="gauge_cls-13"
                          d="M130.33,75.07l12.43-10.43a55.66,55.66,0,0,0-5.59-5.59L126.74,71.48A39.24,39.24,0,0,1,130.33,75.07Z"/>
                    <path class="gauge_cls-15"
                          d="M153.25,82.79,138,88.33a38.55,38.55,0,0,1,1.31,4.91l16-2.82A54.23,54.23,0,0,0,153.25,82.79Z"/>
                    <path class="gauge_cls-11"
                          d="M121.24,67.43a38.83,38.83,0,0,1,4.16,2.92l10.42-12.43a55.21,55.21,0,0,0-6.47-4.54Z"/>
                    <path class="gauge_cls-9"
                          d="M131.46,76.41a40.31,40.31,0,0,1,2.92,4.16l14.05-8.12A56.06,56.06,0,0,0,143.89,66Z"/>
                    <path class="gauge_cls-15"
                          d="M62.49,93.24a40.29,40.29,0,0,1,1.31-4.91L48.56,82.79a54.23,54.23,0,0,0-2,7.63Z"/>
                    <path class="gauge_cls-14"
                          d="M71.48,126.74,59.05,137.17a55.66,55.66,0,0,0,5.59,5.59l10.43-12.43A39.24,39.24,0,0,1,71.48,126.74Z"/>
                    <path class="gauge_cls-16"
                          d="M134.38,121.24a40.31,40.31,0,0,1-2.92,4.16l12.43,10.42a55.21,55.21,0,0,0,4.54-6.47Z"/>
                    <path class="gauge_cls-17"
                          d="M125.4,131.46a40.31,40.31,0,0,1-4.16,2.92l8.11,14.05a55.21,55.21,0,0,0,6.47-4.54Z"/>
                    <path class="gauge_cls-18"
                          d="M140.05,101.78a38.37,38.37,0,0,1-.43,5.06l16,2.82a55.22,55.22,0,0,0,.68-7.88Z"/>
                    <path class="gauge_cls-19"
                          d="M137.4,115.12a39.34,39.34,0,0,1-2.15,4.6l14.05,8.11a55,55,0,0,0,3.35-7.16Z"/>
                    <path class="gauge_cls-20"
                          d="M139.31,108.57a38.4,38.4,0,0,1-1.31,4.9L153.25,119a54.23,54.23,0,0,0,2-7.63Z"/>
                    <path class="gauge_cls-18"
                          d="M62.19,106.84a40.14,40.14,0,0,1-.44-5.06H45.53a55.22,55.22,0,0,0,.68,7.88Z"/>
                    <path class="gauge_cls-20"
                          d="M63.8,113.47a40.13,40.13,0,0,1-1.31-4.9l-16,2.82a54.23,54.23,0,0,0,2,7.63Z"/>
                    <path class="gauge_cls-16"
                          d="M70.35,125.4a38.83,38.83,0,0,1-2.92-4.16l-14.05,8.11a55.21,55.21,0,0,0,4.54,6.47Z"/>
                    <path class="gauge_cls-19"
                          d="M66.55,119.72a37.72,37.72,0,0,1-2.14-4.6l-15.25,5.55a54.91,54.91,0,0,0,3.34,7.16Z"/>
                    <path class="gauge_cls-12"
                          d="M61.75,100A40,40,0,0,1,62.19,95l-16-2.82a55.22,55.22,0,0,0-.68,7.88Z"/>
                    <path class="gauge_cls-17"
                          d="M80.56,134.38a41.29,41.29,0,0,1-4.15-2.92L66,143.89a56.06,56.06,0,0,0,6.47,4.54Z"/>
                    <path class="gauge_cls-21" d="M54.42,36.18,51,31.47l-.71.51,3.43,4.72Z"/>
                    <path class="gauge_cls-21" d="M47.92,41.4,44,37.06l-.65.59L47.26,42Z"/>
                    <path class="gauge_cls-21" d="M42,47.26l-4.33-3.9c-.2.21-.39.43-.59.65l4.34,3.91Z"/>
                    <path class="gauge_cls-21" d="M61.44,31.67l-2.91-5c-.26.14-.51.29-.76.44l2.91,5Z"/>
                    <path class="gauge_cls-21" d="M84.76,22.86l-1.2-5.69-.86.18,1.21,5.7Z"/>
                    <path class="gauge_cls-21"
                          d="M68.89,27.92,66.52,22.6l-.8.36,2.37,5.32C68.35,28.15,68.62,28,68.89,27.92Z"/>
                    <path class="gauge_cls-21" d="M76.69,25l-1.8-5.53-.83.27,1.8,5.54Z"/>
                    <path class="gauge_cls-21"
                          d="M21.22,100.9c0-.14,0-.29,0-.43H15.34v.87h5.89C21.23,101.2,21.22,101.05,21.22,100.9Z"/>
                    <path class="gauge_cls-21" d="M93,21.61l-.61-5.78-.87.09.61,5.79Z"/>
                    <path class="gauge_cls-21" d="M25.24,75.86l-5.58-1.81-.27.83L25,76.69Z"/>
                    <path class="gauge_cls-21"
                          d="M180.19,93,186,92.4c0-.3,0-.59-.09-.88l-5.85.62C180.13,92.43,180.17,92.72,180.19,93Z"/>
                    <path class="gauge_cls-21" d="M36.7,53.71,32,50.28l-.52.71,4.73,3.43Z"/>
                    <path class="gauge_cls-21"
                          d="M28.27,68.09l-5.35-2.38c-.11.26-.24.53-.35.8l5.35,2.38C28,68.62,28.15,68.35,28.27,68.09Z"/>
                    <path class="gauge_cls-21" d="M32.11,60.68l-5.06-2.92c-.16.25-.3.5-.44.76l5.06,2.92Z"/>
                    <path class="gauge_cls-21"
                          d="M21.71,92.14l-5.85-.62c0,.29-.07.58-.1.88l5.85.61C21.64,92.72,21.68,92.43,21.71,92.14Z"/>
                    <path class="gauge_cls-21" d="M170.14,61.44l5.06-2.92c-.14-.26-.28-.51-.44-.76l-5.07,2.92Z"/>
                    <path class="gauge_cls-21" d="M165.62,54.42,170.36,51l-.52-.71-4.73,3.43Z"/>
                    <path class="gauge_cls-21" d="M160.41,47.92,164.75,44c-.2-.22-.39-.44-.59-.65l-4.34,3.9Z"/>
                    <path class="gauge_cls-21" d="M154.54,42l3.91-4.34-.65-.59-3.91,4.34Z"/>
                    <path class="gauge_cls-21"
                          d="M179,84.76l5.74-1.22-.18-.85-5.75,1.22C178.82,84.19,178.89,84.48,179,84.76Z"/>
                    <path class="gauge_cls-21"
                          d="M173.88,68.89l5.36-2.38-.36-.81-5.35,2.39C173.65,68.35,173.77,68.62,173.88,68.89Z"/>
                    <path class="gauge_cls-21" d="M176.83,76.69l5.58-1.81c-.08-.27-.17-.56-.26-.83l-5.59,1.81Z"/>
                    <path class="gauge_cls-21" d="M133.72,28.28,136.09,23l-.81-.36-2.36,5.32Z"/>
                    <path class="gauge_cls-21" d="M126,25.25l1.8-5.54-.84-.27L125.11,25Z"/>
                    <path class="gauge_cls-21" d="M117.9,23.05l1.21-5.7-.86-.18L117,22.86Z"/>
                    <path class="gauge_cls-21" d="M109.67,21.71l.61-5.79-.88-.09-.6,5.78Z"/>
                    <path class="gauge_cls-21"
                          d="M141.13,32.11l2.91-5-.76-.44-2.91,5C140.62,31.82,140.87,32,141.13,32.11Z"/>
                    <path class="gauge_cls-21" d="M100.9,21.22h.44V15.42h-.87v5.81Z"/>
                    <path class="gauge_cls-21" d="M148.09,36.7,151.52,32l-.71-.51-3.43,4.71Z"/>
                    <path class="gauge_cls-21"
                          d="M23.05,83.91,17.3,82.69c-.07.28-.12.57-.18.85l5.74,1.22C22.92,84.48,23,84.19,23.05,83.91Z"/>
                    <path class="gauge_cls-21" d="M147.38,165.62l3.5,4.82c.24-.17.48-.34.71-.52l-3.5-4.81Z"/>
                    <path class="gauge_cls-21"
                          d="M159.82,154.54l4.42,4,.58-.65-4.41-4C160.21,154.11,160,154.33,159.82,154.54Z"/>
                    <path class="gauge_cls-21" d="M140.37,170.14l3,5.15c.26-.14.51-.29.76-.44l-3-5.16Z"/>
                    <path class="gauge_cls-21" d="M153.89,160.41l4,4.42.65-.59-4-4.42Z"/>
                    <path class="gauge_cls-21"
                          d="M21.61,108.8l-5.86.61.09.88,5.87-.62C21.67,109.38,21.64,109.09,21.61,108.8Z"/>
                    <path class="gauge_cls-21"
                          d="M180.1,109.67l5.87.62.09-.88-5.87-.61C180.17,109.09,180.13,109.38,180.1,109.67Z"/>
                    <path class="gauge_cls-21" d="M186.47,100.47h-5.89v.87h5.89v-.87Z"/>
                    <path class="gauge_cls-21" d="M173.53,133.72l5.41,2.41.36-.81-5.42-2.4Z"/>
                    <path class="gauge_cls-21" d="M169.69,141.13l5.14,3,.44-.76-5.13-3Z"/>
                    <path class="gauge_cls-21" d="M165.11,148.09l4.8,3.49.52-.71-4.81-3.49Z"/>
                    <path class="gauge_cls-21" d="M176.56,126l5.63,1.83.27-.84-5.63-1.83Z"/>
                    <path class="gauge_cls-21"
                          d="M178.76,117.9l5.78,1.23.18-.86L179,117.05C178.89,117.33,178.82,117.62,178.76,117.9Z"/>
                    <path class="gauge_cls-21"
                          d="M31.67,140.37l-5.13,3,.44.76,5.13-3C32,140.87,31.82,140.62,31.67,140.37Z"/>
                    <path class="gauge_cls-21" d="M36.18,147.38l-4.8,3.49.52.71,4.8-3.49Z"/>
                    <path class="gauge_cls-21" d="M41.4,153.89l-4.42,4c.2.22.4.43.59.65l4.41-4Z"/>
                    <path class="gauge_cls-21" d="M47.26,159.82l-4,4.42.65.59,4-4.42Z"/>
                    <path class="gauge_cls-21"
                          d="M27.92,132.92l-5.41,2.4.36.81,5.41-2.41C28.15,133.45,28,133.18,27.92,132.92Z"/>
                    <path class="gauge_cls-21"
                          d="M22.86,117.05l-5.77,1.22.18.86,5.78-1.23C23,117.62,22.92,117.33,22.86,117.05Z"/>
                    <path class="gauge_cls-21" d="M25,125.11l-5.62,1.83.27.83L25.24,126Z"/>
                    <path class="gauge_cls-21" d="M60.68,169.69l-3,5.16.76.44,3-5.15Z"/>
                    <path class="gauge_cls-21" d="M53.71,165.11l-3.49,4.81c.23.18.47.35.71.52l3.49-4.82Z"/>
                    <path class="gauge_cls-22"
                          d="M64.22,35.17,59.1,26.3c-.64.36-1.27.73-1.9,1.1l5.11,8.86C62.94,35.89,63.58,35.52,64.22,35.17Z"/>
                    <path class="gauge_cls-22"
                          d="M36.13,62.24l-8.75-5.05c-.37.62-.74,1.26-1.1,1.9l8.74,5C35.38,63.5,35.75,62.86,36.13,62.24Z"/>
                    <path class="gauge_cls-22"
                          d="M139.49,36.26l5.12-8.86c-.63-.37-1.26-.74-1.9-1.1l-5.12,8.87C138.23,35.52,138.87,35.89,139.49,36.26Z"/>
                    <path class="gauge_cls-22"
                          d="M25.25,101.34c0-.51,0-1,0-1.53H15.35c0,.39,0,.78,0,1.17s0,.68,0,1h9.91C25.25,101.78,25.25,101.56,25.25,101.34Z"/>
                    <path class="gauge_cls-22"
                          d="M166.79,64.13l8.74-5c-.36-.64-.73-1.28-1.1-1.9l-8.75,5.05C166.06,62.86,166.43,63.5,166.79,64.13Z"/>
                    <path class="gauge_cls-22" d="M100.9,25.69H102V15.42H99.81V25.7Z"/>
                    <path class="gauge_cls-22"
                          d="M166.07,139.79l8.42,4.87c.38-.63.74-1.26,1.1-1.9l-8.43-4.87C166.8,138.53,166.44,139.17,166.07,139.79Z"/>
                    <path class="gauge_cls-22"
                          d="M138,167.31l4.8,8.31c.64-.36,1.27-.73,1.9-1.1l-4.8-8.32C139.24,166.58,138.61,167,138,167.31Z"/>
                    <path class="gauge_cls-22"
                          d="M186.46,99.81h-9.92c0,.51,0,1,0,1.53,0,.22,0,.44,0,.66h9.91c0-.34,0-.68,0-1S186.47,100.2,186.46,99.81Z"/>
                    <path class="gauge_cls-22"
                          d="M34.65,137.89l-8.43,4.87c.36.64.72,1.27,1.09,1.9l8.43-4.87C35.37,139.17,35,138.53,34.65,137.89Z"/>
                    <path class="gauge_cls-22"
                          d="M61.94,166.2l-4.8,8.32,1.89,1.1,4.8-8.31C63.2,167,62.56,166.58,61.94,166.2Z"/>
                    <rect class="gauge_cls-23" x="77.58" y="159.06" width="48.64" height="22.75" rx="4.16"/>
                </g>
            </g>
        </svg>

        <!-- TEXTOS RADIAL -->
        <div id="weight" style="text-align: center;" :style="formattedWeightStyle">{{formattedWeightDifference}} kg</div>

        <div id="radial-indicator-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160.3 21.54" :style="indicatorStyle" >
                <g id="Capa_2" data-name="Capa 2">
                    <g id="Capa_1-2" data-name="Capa 1">
                        <path class="aguja-radial_cls-1"
                              d="M29.1,21.5a10.51,10.51,0,0,0,9.2-7.6L160.3,0,37.7,6.7A10.44,10.44,0,0,0,18.1,8.9L0,7.7l.5,5.8L1,19.3l17.7-4.2A10.05,10.05,0,0,0,29.1,21.5Zm-6.7-9.9a5.82,5.82,0,1,1,6.3,5.3A5.82,5.82,0,0,1,22.4,11.6Z"/>
                        <circle class="aguja-radial_cls-1" cx="28.1" cy="11.2" r="3.5"/>
                        <path class="aguja-radial_cls-1"
                              d="M32.1,10.9a4,4,0,1,0-3.6,4.3A4.22,4.22,0,0,0,32.1,10.9Z"/>
                    </g>
                </g>
            </svg>
        </div>

    </div>

</template>

<script>
export default {
    name: "RadialGraph",
    props:{
        percentage: Number,
        weightDifference: Number,
        okMaxPercentage: Number
    },
    methods:{
        roundNumber(number, numberOfDecimals){
            let aux = Math.pow(10, numberOfDecimals) ;
            return Math.round( number * aux) / aux;
        },
        beautifyNumber(number){
            return this.roundNumber(number, 2);
        }
    },
    computed:{
        indicatorStyle(){
            var percentage = this.percentage;
            if (percentage > 100 || percentage < -100) percentage = 100 * (percentage / Math.abs(percentage)) ;
            return {
               // 5 => es un ajuste debido al angulo inicial de la aguja,
                // 240 => es el angulo necesario para llevar la agua al inicio,
                // 3 => es el angulo valido (300º) dividido entre 100 para calcular el angulo actual
                transform:  `translate(-17.5%, -17.5%) rotate(${ (3 * (percentage/2))-150 + 65 }deg)`,
                transitionDuration: `0.25s`
            }
        },
        formattedWeightStyle(){
            return {
                color: ( 0 <= this.percentage && this.percentage < this.okMaxPercentage) ? '#008000' : 'red'
            }
        },
        formattedWeightDifference(){
            return `${this.weightDifference > 0?'+':''}${this.roundNumber(this.weightDifference, 3)}`
        }
    }
}
</script>

<style scoped>

/* Aguja Gauge*/
.aguja-radial_cls-1 {
    fill: #5f5f5f;
}

/* Grafico Gauge*/

.gauge_cls-1 {
    fill: url(#linear-gradient);
}

.gauge_cls-2 {
    fill: url(#linear-gradient-2);
}

.gauge_cls-3 {
    fill: url(#linear-gradient-3);
}

.gauge_cls-4 {
    fill: url(#linear-gradient-4);
}

.gauge_cls-5 {
    fill: url(#radial-gradient);
}

.gauge_cls-6 {
    fill: #abe939;
}

.gauge_cls-7 {
    fill: #b2e939;
}

.gauge_cls-8 {
    fill: #cfe939;
}

.gauge_cls-9 {
    fill: #db8b23;
}

.gauge_cls-10 {
    fill: #da8723;
}

.gauge_cls-11 {
    fill: #e1cb32;
}

.gauge_cls-12 {
    fill: #d8751f;
}

.gauge_cls-13 {
    fill: #dc8f24;
}

.gauge_cls-14 {
    fill: #d12811;
}

.gauge_cls-15 {
    fill: #da8322;
}

.gauge_cls-16 {
    fill: #d24015;
}

.gauge_cls-17 {
    fill: #d0100f;
}

.gauge_cls-18 {
    fill: #d6661c;
}

.gauge_cls-19 {
    fill: #d34b17;
}

.gauge_cls-20 {
    fill: #d45719;
}

.gauge_cls-21 {
    fill: #777;
}

.gauge_cls-22 {
    fill: #535353;
}

.gauge_cls-23 {
    fill: #fff;
    stroke: #000;
    stroke-miterlimit: 10;
    stroke-width: 0.5px;
}
</style>
